import React from 'react';
import { useTranslation } from 'react-i18next';
import './css/PrivacyPolicy.css';

function PrivacyPolicy() {
  const { t } = useTranslation();

  const sections = Array.from({ length: 10 }, (_, i) => i + 1);

  return (
    <div className="privacy-policy-container">
      <h2>{t('privacy.title')}</h2>
      <p className="privacy-effective-date">{t('privacy.effectiveDate')}</p>

      {sections.map(num => (
        <section key={num} className="privacy-section">
          <h3>{t(`privacy.section${num}.title`)}</h3>
          <div className="privacy-content">
            {t(`privacy.section${num}.content`).split('\n').map((line, idx) => (
              <p key={idx}>{line}</p>
            ))}
          </div>
        </section>
      ))}
    </div>
  );
}

export default PrivacyPolicy;
